import { AuthCard } from '../cards';
import { LoginForm } from '../forms';

const LoginPanel = () => {
    return (
        <AuthCard
            title="Manager Login"
            form={<LoginForm />}
        />
    );
};

export default LoginPanel;
